export default __webpack_public_path__ + "static/media/icon_timer_stop.c0c28ac1.svg";